import config, { DEFAULT_DEMO_HOST } from 'hostsConfig';

const currentHost = window.location.host;

let innerAppHost = DEFAULT_DEMO_HOST;
if (config.has(currentHost)) {
  const innerHost = config.get(currentHost);
  if (/^https?:\/\//.test(innerHost)) {
    innerAppHost = innerHost;
  } else {
    let protocol = 'https';
    if (innerHost.indexOf('localhost') > -1) {
      protocol = 'http';
    }
    innerAppHost = `${protocol}://${innerHost}`;
  }
}

export const prepareUrl = (lang, path = '') => {
  return innerAppHost + `/${lang}` + path;
};

const getFormattedBalanceDigits = (amount, currencySettings = {}) => {
  const maxDisplayDigits = currencySettings?.maxDisplayDigits ?? 9;
  const maxDecimalPlaces = currencySettings?.maxDecimalPlaces ?? 2;

  const roundedAmount = Number(amount?.toFixed(maxDecimalPlaces));
  const formatted = Number(
    roundedAmount
      .toLocaleString('en-US', { maximumSignificantDigits: maxDisplayDigits })
      .replace(/,/g, ''),
  );

  return formatted;
}
export const getFormattedBalance = (amount, currencySettings = {}) => {
  const { separator = 'comma' } = currencySettings ?? {};
  const formatted = getFormattedBalanceDigits(amount, currencySettings)
    .toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 20,
    })
    .replace(/,/g, ' ');
  return separator === 'dot'
    ? formatted.replaceAll(',', '.')
    : formatted.replaceAll('.', ',');
}